import { useRefract } from "refract-rxjs";

import { type ApolloResult } from "../../shared/models";
import { makeUTCStartEndTimestamp } from "../converters";
import { type RetentionTotalEffectInput, type RetentionTotalEffectOutput, retentionTotalEffect } from "../effects";

import { useLensUniquesTotalQuery } from "./useLensUniquesTotalQuery";

export const useRetentionData = (skipQuery?: boolean, diffRange?: number): ApolloResult<RetentionTotalEffectOutput> => {
    const { startTime, endTime } = makeUTCStartEndTimestamp(1, -1 * (diffRange ?? 0));

    const { data, error, loading } = useLensUniquesTotalQuery(skipQuery ? null : endTime, skipQuery ? null : startTime);

    const metricsData = useRefract<RetentionTotalEffectInput, RetentionTotalEffectOutput>(retentionTotalEffect, {
        data,
        loading,
    });

    return { ...metricsData, error, loading };
};
